import React from 'react';
import * as S from './styles';

export const ComponentInputAcessibilidade = props => {
  return (
    <S.InputTextAcessibilidade id="refInputTextAcessibilidade">
      {props?.value || props?.placeholder}
    </S.InputTextAcessibilidade>
  );
};

ComponentInputAcessibilidade.propTypes = {};

ComponentInputAcessibilidade.defaultProps = {};

export default ComponentInputAcessibilidade;
